module.exports = __webpack_public_path__ + "img/berndmueller.fd4059f8.png";